import PropTypes from "prop-types";
import React from "react";

import ConfirmBuyerLayout from "./ConfirmBuyerLayout";
import PhoneTag from "./PhoneTag";
import EmailTag from "./EmailTag";

const ConfirmStream = ({ agent, leadEmail, design }) => {
  const { phoneNumber, email } = agent;

  return (
    <ConfirmBuyerLayout design={design}>
      <h1>Please Verify Your Email</h1>
      <p>
        You should receive an invitation link to Cloud Streams by email (sent to{" "}
        {leadEmail})
      </p>
      <p>
        Please take a minute to confirm and be the first to know when new homes
        hit the market or price changes on homes you like.
      </p>

      <p>
        {" "}
        {/* Not sure how to format this line to make it easier to read */}
        If you need any assistance, please{" "}
        {phoneNumber ? (
          <span>
            give me a call at <PhoneTag phoneNumber={phoneNumber} /> or
          </span>
        ) : null}{" "}
        email me at <EmailTag email={email} />
      </p>
    </ConfirmBuyerLayout>
  );
};

ConfirmStream.propTypes = {
  agent: PropTypes.object.isRequired,
  leadEmail: PropTypes.string.isRequired,
  design: PropTypes.object.isRequired
};

export default ConfirmStream;
